module.exports = __webpack_public_path__ + "img/pix.6d0721ea.png";